export class DashboardTemplate {
  id!: string;
  name!: string;
  datasetId!: string;
}